window.addEventListener('DOMContentLoaded', function () {
    if (document.getElementsByClassName('product-details__item--variant-option').length > 0) {
        const variants = document.getElementsByClassName('product-details__item--variant-option')

        for (let i = 0; i < variants.length; i++) {
            const e = variants[i];

            if (e.innerHTML.indexOf("Title") != -1) {
                e.remove();
            }
        }
    }
})


window.addEventListener('load', function () {
    if (document.getElementsByClassName('AddToCartText').length > 0) {
        if (document.documentElement.getAttribute('lang') === 'fr') {
            let variants = document.getElementsByClassName('AddToCartText')
            for (let i = 0; i < variants.length; i++) {
                const e = variants[i];
                console.log(e)
                if (e.innerHTML.indexOf("ADD TO CART") != -1) {
                    e.innerHTML = "AJOUTER AU PANIER";
                }
            }
        }
    }
})